<template>
  <div
    class="shopper"
    :class="{ 'shopper--closed': !launcherOpen }"
    @click.prevent="
      evt => {
        launcherOpen = false
      }
    "
  >
    <div
      class="shopper__container"
      :class="{ 'shopper__container--closed': !launcherOpen }"
    >
      <div
        class="shopper__list"
        :class="{ 'shopper__list--closed': !launcherOpen }"
      >
        <ShopperProduct
          v-for="(product, index) in shoppableLinks"
          :key="index"
          :linkObject="product"
        />
      </div>
      <div
        class="shopper__launcher"
        :class="{ 'shopper__launcher--open-mobile': launcherOpen }"
        @click.stop="
          evt => {
            launcherOpen = true
          }
        "
      ></div>
      <div
        class="shopper__close-button"
        :class="{ 'shopper__close-button--open-mobile': launcherOpen }"
        @click.stop="
          evt => {
            launcherOpen = false
          }
        "
      >
        X
      </div>
    </div>
  </div>
</template>

<script>
import ShopperProduct from "./ShopperProduct"

import { mapGetters } from "vuex"

export default {
  data: () => ({
    launcherOpen: false
  }),

  mounted() {},

  components: {
    ShopperProduct
  },

  methods: {},

  computed: {
    ...mapGetters("partyStore", ["shoppableLinks"])
  }
}
</script>

<style lang="scss">
.shopper {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 100%;

  &__container {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: auto;
    padding: 56px 15px 20px;
    top: 15vh;
    right: 0;
    background-color: rgba(255, 255, 255, 0.8);
    transition: right 0.3s ease;

    &--closed {
      right: -100%;
    }
  }

  &__list {
    box-sizing: border-box;
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    transition: opacity 0.2s linear;

    &--closed {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__launcher {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 100%;
    width: 50px;
    height: 120px;
    background-color: #e354db;
    color: black;
    background-image: url("~@/assets/shop_label.svg");
    background-repeat: no-repeat;
    background-size: 18px;
    background-position: center;
  }

  &__close-button {
    cursor: pointer;
    box-sizing: border-box;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 40px;
    height: 40px;
    border: 2px solid black;
    color: black;
    border-radius: 999px;
    font-family: Karla;
    font-weight: bold;
    font-size: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.1s linear;

    &:hover {
      color: white;
      background-color: black;
    }
  }

  // Landscape for phones
  @media (max-height: 450px) {
    &__container {
      padding-top: 40px;
    }

    &__close-button {
      height: 25px;
      width: 25px;
      font-size: 1rem;
    }
  }

  @media (max-width: 600px) {
    z-index: 8;
    right: 0;

    background-color: rgba(0, 0, 0, 0.25);
    transition: background-color 0.3s linear;

    &--closed {
      background-color: transparent;
      pointer-events: none;
    }

    &__container {
      position: relative;
      width: 90%;
      margin: 0 auto;
      transition: background-color 0.1s linear;

      &--closed {
        right: 0;
        background-color: transparent;
      }
    }

    &__launcher {
      position: fixed;
      pointer-events: all;
      top: 10%;
      right: 0;
      width: 50px;
      background-size: 12px;
      height: 80px;
      transition: opacity 0.1s linear;

      &--open-mobile {
        opacity: 0;
      }
    }

    &__close-button {
      opacity: 0;
      pointer-events: none;

      &--open-mobile {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
}
</style>
